import { render, staticRenderFns } from "./commentOperationDialog.vue?vue&type=template&id=0c3f8c31&scoped=true"
import script from "./commentOperationDialog.vue?vue&type=script&lang=js"
export * from "./commentOperationDialog.vue?vue&type=script&lang=js"
import style0 from "./commentOperationDialog.vue?vue&type=style&index=0&id=0c3f8c31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f8c31",
  null
  
)

export default component.exports